/**
 * Check if running a development build
 */
// eslint-disable-next-line import/prefer-default-export
export const isDevelopment = () => process.env.NODE_ENV === 'development';
